import React, { useState } from "react";
import { Scan } from "lucide-react";
import styles from "./FullScreenToggle.module.scss";

const FullScreenToggle = ({ className }) => {
  const [fullscreen, setFullscreen] = useState(false);

  const toggleFullScreen = () => {
    if (!fullscreen) {
      document.documentElement.requestFullscreen();
      setFullscreen(true);
    } else {
      document.exitFullscreen();
      setFullscreen(false);
    }
  };

  return (
    <li className={className}>
      <span className="header-fullscreen">
        <Scan
          size={19}
          className={`header-icon ${styles.icon}`}
          onClick={toggleFullScreen}

        />
      </span>
    </li>
  );
};

export default FullScreenToggle;
